import { createAction, props } from '@ngrx/store';
import { IPurposeData, IPurposeModel } from '@partners/api';

export class PurposeActions {
  static reset = createAction('[Purpose] Reset State');
  static load = createAction('[Purpose] Load');
  static loadSuccess = createAction('[Purpose] Load Success', props<{ model: IPurposeModel; data: IPurposeData }>());
  static loadFailure = createAction('[Purpose] Load Failure', props<{ error: any }>());
  static submit = createAction('[Purpose] Submit');
  static submitSuccess = createAction(
    '[Purpose] Submit Success',
    props<{ model: IPurposeModel; data: IPurposeData }>()
  );
  static submitFailure = createAction('[Purpose] Submit Failure', props<{ error: any }>());
}
